var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.content},[_c('div',{class:_vm.$style.box},[_c('div',{class:_vm.$style.right},[_c('div',{class:_vm.$style.mainBox},[(_vm.isLoading)?_c('StubPreloaderForm',{attrs:{"layout":"page"}}):_vm._t("form")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }